import { c as _c } from "react/compiler-runtime";
import { readCurrencyFragment } from "@opensea/app-kit";
import { classNames, Flex, FlexColumn, Input, Separator, UnstyledButton } from "@opensea/ui-kit";
import { useDebounceValue } from "@opensea/ui-kit/hooks";
import { Close, Search } from "@opensea/ui-kit/icons";
import { useMemo, useState } from "react";
import { useTranslations } from "use-intl";
import { ChainSelect } from "./ChainSelect";
import { OwnedCurrencies } from "./components/OwnedCurrencies";
import { PrioritizedCurrencies } from "./components/PrioritizedCurrencies";
import { TopCurrencies } from "./components/TopCurrencies";
import { useSearchCurrenciesQuery } from "./hooks/useSearchCurrenciesQuery";
export const CurrencySelectContent = t0 => {
  const $ = _c(51);
  const {
    chain: chainProp,
    direction,
    onSelectCurrency,
    removeSwapDisabledCurrencies,
    className,
    onClose
  } = t0;
  const t = useTranslations("wallet.CurrencySelectContent");
  const [selectedChain, setSelectedChain] = useState(chainProp ?? "all");
  const [searchValue, setSearchValue] = useState("");
  let t1;
  if ($[0] !== searchValue) {
    t1 = searchValue.trim();
    $[0] = searchValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [debouncedSearchValue] = useDebounceValue(t1, 500);
  let t2;
  if ($[2] !== debouncedSearchValue || $[3] !== selectedChain) {
    t2 = {
      query: debouncedSearchValue,
      chain: selectedChain
    };
    $[2] = debouncedSearchValue;
    $[3] = selectedChain;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    currencies: data,
    fetching
  } = useSearchCurrenciesQuery(t2);
  let t3;
  let t4;
  if ($[5] !== data) {
    t4 = data.map(_temp);
    $[5] = data;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  t3 = t4;
  const searchCurrencies = t3;
  let t5;
  if ($[7] !== className) {
    t5 = classNames("h-full overflow-hidden", className);
    $[7] = className;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Close fill="text-secondary" size={22} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== onClose) {
    t7 = <UnstyledButton onClick={onClose}>{t6}</UnstyledButton>;
    $[10] = onClose;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e => setSearchValue(e.target.value);
    t9 = {
      Input: {
        className: "!text-md"
      }
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t) {
    t10 = t("searchPlaceholder");
    $[14] = t;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Search fill="text-secondary" size={22} />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== searchValue || $[18] !== t10 || $[19] !== t7) {
    t12 = <Flex className="px-4 py-3"><Input className="gap-3.5 font-sans" endEnhancer={t7} onChange={t8} overrides={t9} placeholder={t10} size="sm" startEnhancer={t11} value={searchValue} variant="ghost" /></Flex>;
    $[17] = searchValue;
    $[18] = t10;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator />;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== direction || $[23] !== selectedChain) {
    t14 = <ChainSelect className="flex flex-wrap p-4" direction={direction} onSelectChain={setSelectedChain} value={selectedChain} />;
    $[22] = direction;
    $[23] = selectedChain;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Separator />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== direction || $[27] !== fetching || $[28] !== onSelectCurrency || $[29] !== searchValue || $[30] !== selectedChain) {
    t16 = direction === "from" && <OwnedCurrencies fetching={fetching} onSelectCurrency={onSelectCurrency} searchValue={searchValue} selectedChain={selectedChain} />;
    $[26] = direction;
    $[27] = fetching;
    $[28] = onSelectCurrency;
    $[29] = searchValue;
    $[30] = selectedChain;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== onSelectCurrency || $[33] !== searchValue.length || $[34] !== selectedChain) {
    t17 = selectedChain !== "all" && searchValue.length === 0 && <PrioritizedCurrencies onSelectCurrency={onSelectCurrency} selectedChain={selectedChain} />;
    $[32] = onSelectCurrency;
    $[33] = searchValue.length;
    $[34] = selectedChain;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const t18 = searchValue ? searchCurrencies : undefined;
  let t19;
  if ($[36] !== fetching || $[37] !== onSelectCurrency || $[38] !== removeSwapDisabledCurrencies || $[39] !== selectedChain || $[40] !== t18) {
    t19 = <TopCurrencies fetching={fetching} onSelectCurrency={onSelectCurrency} removeSwapDisabledCurrencies={removeSwapDisabledCurrencies} searchCurrencies={t18} selectedChain={selectedChain} />;
    $[36] = fetching;
    $[37] = onSelectCurrency;
    $[38] = removeSwapDisabledCurrencies;
    $[39] = selectedChain;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t16 || $[43] !== t17 || $[44] !== t19) {
    t20 = <FlexColumn className="scrollbar-hidden flex-1 gap-4 overflow-y-scroll p-4 pb-3">{t16}{t17}{t19}</FlexColumn>;
    $[42] = t16;
    $[43] = t17;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t12 || $[47] !== t14 || $[48] !== t20 || $[49] !== t5) {
    t21 = <FlexColumn className={t5}>{t12}{t13}{t14}{t15}{t20}</FlexColumn>;
    $[46] = t12;
    $[47] = t14;
    $[48] = t20;
    $[49] = t5;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  return t21;
};
function _temp(currency) {
  return readCurrencyFragment(currency);
}